import { AssetsAndLiabilities } from '@/app/(private)/company/(Documents)/AssetsAndLiabilities';
import { SignGuaranteeDocument } from '@/app/(private)/company/(Documents)/SignGuaranteeDocument';
import { SignPoaDocument } from '@/app/(private)/onboarding/(SignPoa)/SignPoaDocument';
import {
  CHARGE_TEMPLATE_ID,
  GUARANTEE_UNDERTAKING_TEMPLATE_ID,
  PERSONAL_LIABILITY_TEMPLATE_ID,
  STATEMENT_OF_ASSETS_LIABILITIES_TEMPLATE_ID,
} from '@/constants/documents';
import { Documents } from '@/types/company';
import { DocumentStrategy } from '@/types/documents';
import { IStrategy } from '@/types/strategy';
import { find, includes } from 'lodash';

class DocumentStrategyRegistry
  implements IStrategy<Documents.DocumentType, DocumentStrategy>
{
  private strategies: DocumentStrategy[] = [];

  constructor() {
    this.register(
      {
        match: (doc) =>
          doc.template_id === STATEMENT_OF_ASSETS_LIABILITIES_TEMPLATE_ID,
        render: ({ document, open, onClose }) => (
          <AssetsAndLiabilities
            isModalOpen={open}
            onModalClose={onClose}
            document={document}
          />
        ),
      },
      {
        match: (doc) =>
          includes(
            [
              PERSONAL_LIABILITY_TEMPLATE_ID,
              GUARANTEE_UNDERTAKING_TEMPLATE_ID,
              CHARGE_TEMPLATE_ID,
            ],
            doc?.template_id
          ),
        render: ({ document, open, onClose }) => (
          <SignGuaranteeDocument
            document={document}
            open={open}
            onClose={onClose}
          />
        ),
      },
      {
        match: (doc) => doc.tag === 'attorney' && doc.internal === false,
        render: ({ document, open, onClose }) => (
          <SignPoaDocument document={document} open={open} onClose={onClose} />
        ),
      }
    );
  }

  register(...strategies: DocumentStrategy[]): void {
    this.strategies.push(...strategies);
  }

  match(doc: Documents.DocumentType): DocumentStrategy | null {
    return find(this.strategies, (strategy) => strategy.match(doc)) ?? null;
  }
}

// Singleton instance
export const documentStrategyRegistry = new DocumentStrategyRegistry();
